
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { dataModule } from '@/store/data';
import NHint from '@/uikit/hint/NHint.vue';
import NTooltip from '@/uikit/hint/NTooltip.vue';

@Options({
  name: 'DetectorsInfo',
  components: { NHint, NTooltip }
})
export default class DetectorsInfo extends Vue {
  @Prop({ type: String, required: true })
  readonly sourceType!: string;

  @Prop({ type: Number, required: true })
  readonly sourceId!: number;

  reference: any = null;

  private names: string = '';

  mounted() {
    this.applyNames();
  }

  @Watch('sourceId')
  applyNames() {
    this.names = '';
    this.$nextTick(async () => {
      this.names = await this.getNames();
    });
  }

  async getNames() {
    let item: any = undefined;
    if (this.sourceType === 'camera') {
      item = await dataModule.camerasModule.getById(this.sourceId);
    }
    if (this.sourceType === 'video_archive') {
      item = await dataModule.videosModule.getById(this.sourceId);
    }
    const detectors = item?.stream_settings?.detectors;
    let names = [];
    if (detectors?.face) {
      names.push(this.$t('common.faces'));
    }
    if (detectors?.body) {
      names.push(this.$t('common.bodies'));
    }
    if (detectors?.car) {
      names.push(this.$t('common.cars'));
    }
    if (names.length) {
      return names.join(', ');
    }
    return this.$t('common.none');
  }
}
